import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import { getFieldOptions } from "../common/selectors";
import { anyNotBlank, notBlank } from "../common/general";
import { omit, mergeRight, not, propOr } from "ramda";
import IntlTextField from "./IntlTextField";

const CustomizableTextField = props => {
  const {
    fieldOption,
    name,
    defaultLabel,
    hideByDefault = false,
    value,
    onChange,
    error,
    helperText,
    onBlur,
    xs,
    sm,
    md,
    marginTop = 0,
    inputProps,
    params = {},
  } = props;

  //-- Maybe pull this into a useEffect
  if (notBlank(inputProps)) {
    params.inputProps = mergeRight(propOr("inputProps", params), inputProps);
  }

  const fieldOptions = useSelector(getFieldOptions);
  const [showField, setShowField] = useState(true);
  const [label, setLabel] = useState("");
  useEffect(() => {
    if (notBlank(fieldOptions[fieldOption])) {
      const option = fieldOptions[fieldOption];
      setShowField(!option.hidden);

      if (notBlank(option.fieldLabel)) {
        setLabel(option.fieldLabel);
      } else if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    } else {
      setShowField(not(hideByDefault));

      if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    }
  }, [fieldOptions, fieldOption, defaultLabel, hideByDefault, value]);

  const [fieldValue, setFieldValue] = useState("");
  useEffect(() => {
    if (value != null) {
      setFieldValue(value);
    } else if (
      fieldOptions[fieldOption] &&
      notBlank(fieldOptions[fieldOption].defaultValue)
    ) {
      setFieldValue(fieldOptions[fieldOption].defaultValue);
    }
  }, [fieldOptions, fieldOption, value]);

  const wrapGrid = element => {
    if (anyNotBlank([xs, sm, md])) {
      return (
        <Grid item xs={xs || 12} sm={sm || 6} md={md || 6}>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  const [textFieldProps, setTextFieldProps] = useState({});
  useEffect(() => {
    const required = fieldOptions?.[fieldOption]?.required ?? props?.required;
    const textFieldProps = omit(
      ["defaultLabel", "fieldOption", "hideByDefault", "xs", "sm", "md"],
      props,
    );
    setTextFieldProps({ ...textFieldProps, required });
  }, [props, fieldOption, fieldOptions]);

  return (
    showField &&
    wrapGrid(
      <IntlTextField
        {...params}
        {...textFieldProps}
        style={{ marginTop: marginTop }}
        fullWidth
        type="text"
        variant="standard"
        label={label}
        value={fieldValue}
        onChange={onChange}
        error={error}
        helperText={helperText}
        onBlur={onBlur}
        name={name}
      />,
    )
  );
};

export default CustomizableTextField;
